import { __, contains } from 'ramda';

import { REPLACE_CODES } from 'constants/dictionaries';

export const isReplacing = contains(__, REPLACE_CODES);
